function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "logo",
  d: "M314.827 110.548l-5.362 10.618h.809l2.5-4.95h5.126l2.683 4.955h1.709l-7.337-13.558h-1.719zm-27.241 10.618h1.533v-13.553h-1.533zm19 0h1.553l-3.849-13.553h-1.59l.669 2.342-3.588 9.8-5.2-12.141H292.9l1.277 2.935-2.915 10.618h.749l2.628-9.558 4.221 9.713 1.477-.99 3.377-9.181zm17.834-6.8c-.091-3.633 2.492-6.442 5.407-6.442a4.935 4.935 0 014.2 2.4l.608-1.543a8.577 8.577 0 00-4.8-1.367 6.847 6.847 0 00-7.055 6.96 6.961 6.961 0 007.005 7.04 8.2 8.2 0 005.859-2.442v-5.005h-2.915l1.382 1.377v4.106a5.36 5.36 0 01-4.4 1.07 6.333 6.333 0 01-5.281-6.151zm13.94 6.8h1.533v-13.553h-1.523zm17.809-13.553h7.543l-.719.719h-5.3v4.764h5.231l-.718.724h-4.508v6.633l6.025-.015-.724.729h-6.824zm-12.469 2.533v11.02h.724v-10.06l7.683 10.216.9-.7-.01-13.01h-.718v11.448l-8.588-11.447H341.8zm-30.561 5.354l2.111-4.181 2.261 4.181z",
  transform: "translate(-287.586 -107.412)",
  fill: "#fff",
  fillRule: "evenodd"
});

var SvgImagineLogo = function SvgImagineLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76.13 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImagineLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imagine_logo.fa5f9cc0.svg";
export { ForwardRef as ReactComponent };